import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { mediaInline } from '@atlaskit/adf-schema';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import { getMediaAttrs } from './toDOMAttrs';
var skeletonStyling = "background: ".concat("var(--ds-background-neutral, #091E420F)", ";");
// Matches media
var fallbackAspectRatio = 1.25;

// @nodeSpecException:toDOM patch
export var mediaInlineSpecWithFixedToDOM = function mediaInlineSpecWithFixedToDOM() {
  if (editorExperiment('platform_editor_exp_lazy_node_views', false)) {
    return mediaInline;
  }
  return _objectSpread(_objectSpread({}, mediaInline), {}, {
    toDOM: function toDOM(node) {
      var dataAttrs = getMediaAttrs('mediaInline', node);
      if (node.attrs.type === 'image') {
        var aspectRatio = node.attrs.width && node.attrs.height ? node.attrs.width / node.attrs.height : fallbackAspectRatio;
        return ['span', _objectSpread(_objectSpread({}, dataAttrs), {}, {
          style: 'display: inline-block; transform: translateY(6px)',
          class: 'media-inline-image-wrapper'
        }), ['span', {
          height: '100%',
          width: '100%',
          // Transparent image workaround to control styling
          src: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7',
          style: "display: inline-block; aspect-ratio: ".concat(aspectRatio, "; height: 100%; width: 100%; border-radius: ", "var(--ds-radius-small, 3px)", "; ").concat(skeletonStyling)
        }]];
      } else {
        return ['span', _objectSpread(_objectSpread({}, dataAttrs), {}, {
          style: "display: inline-block; transform: translateY(6px); ".concat(skeletonStyling),
          class: 'media-inline-image-wrapper'
        }), ['span', {
          style: "display: inline-block; height: 100%; width: 100%; aspect-ratio: ".concat(fallbackAspectRatio, ";")
        }]];
      }
    }
  });
};